export function builderWithOptions() {
    return function builder(fn) {
        return fn;
    };
}
export function builderWithoutOptions() {
    return function builder(fn) {
        return fn;
    };
}
